import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TranslateService } from "@ngx-translate/core";
import { OrderStateRenderer } from "./OrderStateRenderer";
import { OrderPauseState } from "./OrderPauseState";
import { LimitOrder } from "./LimitOrder";

export class OrderStateHelper {
  private renderer: OrderStateRenderer;
  constructor(protected orderStateColumn: string, protected translator: TranslateService) {
    this.renderer = new OrderStateRenderer(this.translator);
  }

  public getState(params: any): string {
    let ret: string = null;
    let order: LimitOrder = params.data;

    if (order?.orderState === CubiqTS.OrderState.ACTIVE) {
      if (OrderPauseState.isPausePendingOrderState(params.data)) {
        ret = this.translator.instant("order.state.PAUSE_PENDING");
      } else if (OrderPauseState.isResumePendingOrderState(params.data)) {
        ret = this.translator.instant("order.state.RESUME_PENDING");
      } else if (OrderPauseState.isPausedOrderState(params.data)) {
        ret = this.translator.instant("order.state.PAUSED");
      }
    }

    if (null == ret) {
      // Special flag for modify in acceptance synthetic state now on the order
      let lockType: CubiqTS.LockType =
        order instanceof CubiqTS.OrderDataImpl && order.modifyInAcceptanceFg === true
          ? CubiqTS.LockType.MODIFY_LOCK
          : order.lockType;
      ret = this.renderer.getStateAsString(params.data[this.orderStateColumn], lockType);
    }
    return ret;
  }
}
